export class ArrayUtil {
  // Trie les éléments par 'value'
  static sortByValue<T>(item1: T, item2: T): number {
    if (item1 < item2) return -1;
    if (item1 > item2) return 1;
    return 0;
  }

  static hasDuplicates<T>(arr: T[]): boolean {
    return new Set(arr).size < arr.length;
  }

  static deepClone<T>(arr: T[]): T[] {
    return JSON.parse(JSON.stringify(arr));
  }
}
